import React from "react";
import {Button as MuiButton } from "@material-ui/core/";
import styled from "styled-components";
import { usePreferences, ThemeProps } from "../usePreferences";

export type Props = {
  actionable: boolean;
  text: string;
};

type StyleProps = {actionable: boolean} & ThemeProps;
const StyledCalculateButton = styled(MuiButton)`
  && {
    background-color: ${({ theme, actionable}: StyleProps) =>
      actionable
        ? theme.palette.positiveActionColor
        : `${theme.palette.positiveActionColor}99`};
    border-radius: 4px;
    
    color: ${({actionable}: StyleProps) =>
      actionable
        ? "#FEFFFC"
        : "#8c8c8c"};
    &:hover {
      background-color: ${({ theme, actionable }: StyleProps) =>
        actionable
          ? `${theme.palette.positiveActionColor}B3`
          : `${theme.palette.positiveActionColor}99`};
    }
  }
`;

export const Button = ({ actionable, text }: Props) => {
  const [preferences, _dispatch] = usePreferences();
  return (
    <StyledCalculateButton
      actionable={actionable}
      theme={preferences.theme}
      disabled={!actionable}
    >
      {text}
    </StyledCalculateButton>
  );
};
